import { motion } from 'framer-motion';
import { type BenefitColumn } from 'liftApp/types';
import type { Translate } from 'next-translate';
import React from 'react';
import { Container } from '@/components/elements/Container';
import { MyImage } from '@/components/elements/MyImage';
import { Button } from '@/components/UI/Button';
import { pictureMotion } from '@/animations';
import { ColumnList } from './ColumnList';
import styles from './Columns.module.scss';

interface Props {
	t: Translate;
	title: string;
	data: BenefitColumn[];
	buttonText: string;
	onClick: () => void;
	classes?: {
		columnTitle?: string;
	};
}
export const Columns: React.FC<Props> = ({
	t,
	title,
	data,
	buttonText,
	onClick,
	classes,
}) => {
	const { columnTitle } = classes ?? {};
	return (
		<div className={styles['columns']}>
			<Container className={`container ${styles['columns__container']}`}>
				<h2 className={styles['columns__main-title']}>{title}</h2>
				<ul className={styles['columns__list']}>
					{data.map(column => (
						<li className={styles['columns__column']} key={column.columnTitle}>
							<motion.div
								className={`${styles['columns__image-container']}`}
								{...pictureMotion}
							>
								<MyImage
									imageProps={{
										src: column.image,
										alt: column.columnTitle,
									}}
									settings={{
										classes: {
											picture: `${styles['columns__picture']}`,
											image: `${styles['columns__image']}`,
										},
									}}
								/>
							</motion.div>

							<h3
								className={`${styles['columns__column-title']} ${columnTitle}`}
							>
								{t(column.columnTitle)}
							</h3>

							<ColumnList column={column.items} t={t} />
						</li>
					))}
				</ul>

				<Button
					as='button'
					preset='landing'
					text={buttonText}
					size='large'
					classes={{
						button: styles['columns__button'],
					}}
					onClick={onClick}
				/>
			</Container>
		</div>
	);
};
